import {
  AttributionInsights,
  exampleAttributionInsight,
  PlacementAttributionRows,
} from './AttributionInsights';

/*
 * Note: For placement and device, facebook does not have a clearly defined place for every possibility.
 * It is safe to assume however, that we can word-ify the values we get back to be presentable to a user
 */

export interface PlacementAttributionInsights extends AttributionInsights {
  platform: string; // 'Facebook Feed' | 'Instagram Stories'
  device: string; // 'iPhone' | 'Desktop' | 'Android'
}

export const examplePlacementAttributionInsight: PlacementAttributionInsights = {
  ...exampleAttributionInsight,
  platform: 'Facebook Feed',
  device: 'Desktop',
};

export const placementAttributionBreakdown: PlacementAttributionRows = {
  rows: [examplePlacementAttributionInsight],
  breakdownType: 'Placement',
};
